import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default {
  viewInfo(state, data) {
    state.viewInfo = data
  },
  accountInfo(state, data) {
    for (let key in data) {
      if (data[key] != undefined && data[key] != null)
        Vue.set(state.accountInfo, key, data[key])
    }
    sessionStorage.setItem('accountInfo', JSON.stringify(state.accountInfo))
  },
  confirmBuy(state, data) {
    state.confirmBuy = data
  },
  viewLoading(state, data) {
    state.viewLoading = data
  },
  empowerParams(state, data) {
    state.empowerParams = data
  },
  setAccountInfo(state, data) {
    state.setAccountInfo = data
  },
  businessTab(state, data) {
    state.businessTab = data
  },
}
